'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function (_React$PureComponent) {
  (0, _inherits3.default)(Select, _React$PureComponent);

  function Select() {
    (0, _classCallCheck3.default)(this, Select);
    return (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).apply(this, arguments));
  }

  (0, _createClass3.default)(Select, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          options = _props.options,
          empty = _props.empty,
          value = _props.value,
          readOnly = _props.readOnly,
          size = _props.size,
          color = _props.color,
          className = _props.className,
          _onChange = _props.onChange,
          children = _props.children,
          props = (0, _objectWithoutProperties3.default)(_props, ['options', 'empty', 'value', 'readOnly', 'size', 'color', 'className', 'onChange', 'children']);

      return _react2.default.createElement(
        'label',
        {
          className: (0, _classnames3.default)('select', className, (_classnames = {}, (0, _defineProperty3.default)(_classnames, 'select-' + (_constants.sizeAliases[size] || size), size), (0, _defineProperty3.default)(_classnames, color, _constants.indicatorMap[color]), _classnames)) },
        _react2.default.createElement(
          'select',
          (0, _extends3.default)({}, props, {
            value: toString(value),
            onChange: function onChange(event) {
              return !readOnly && _onChange(children ? event.target.value : toValue(event.target.value, options));
            } }),
          children || renderOptions(options, empty)
        )
      );
    }
  }]);
  return Select;
}(_react2.default.PureComponent);

Select.propTypes = {
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({ label: _propTypes2.default.node, value: _propTypes2.default.any })),
  empty: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
  value: _propTypes2.default.any,
  readOnly: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  size: _propTypes2.default.oneOf(['xs', 's', 'l', 'xl', 'xsmall', 'small', 'large', 'xlarge']),
  color: _propTypes2.default.oneOf(['error', 'warning', 'info', 'success']),
  className: _propTypes2.default.any
};
Select.defaultProps = {
  options: [],
  empty: 'Please select ...',
  value: null,
  onChange: function onChange() {}
};


function renderOptions(options, empty) {
  var emptyOption = empty !== false && _react2.default.createElement(
    'option',
    { key: 0, value: '' },
    empty
  );
  var valueOptions = options.map(function (_ref, i) {
    var label = _ref.label,
        value = _ref.value,
        props = (0, _objectWithoutProperties3.default)(_ref, ['label', 'value']);
    return _react2.default.createElement(
      'option',
      (0, _extends3.default)({}, props, { key: i + 1, value: value }),
      label
    );
  });
  return emptyOption ? [emptyOption].concat((0, _toConsumableArray3.default)(valueOptions)) : valueOptions;
}

function toString(value) {
  return value === null ? '' : String(value);
}

function toValue(string, options) {
  return string === '' ? null : options.reduce(function (acc, _ref2) {
    var value = _ref2.value;
    return String(value) === string ? value : acc;
  }, string);
}

exports.default = Select;